<button class="close-button" @click="$emit('click')"></button>